import { render, staticRenderFns } from "./AlertValidationErrorsFromAJAX.vue?vue&type=template&id=9b385e20"
import script from "./AlertValidationErrorsFromAJAX.vue?vue&type=script&lang=js"
export * from "./AlertValidationErrorsFromAJAX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports